import { TBlogArticleModule } from '@/app/(blogposts)/blog/blog.types';
import { devLog } from '@/lib/logging';
import clsx from 'clsx';
import { BlogArticleModuleBlockQuote } from '../../BlogArticleModuleBlockQuote';
import { BlogArticleModuleFAQs } from '../../BlogArticleModuleFAQs';
import { BlogArticleModuleInfoCallout } from '../../BlogArticleModuleInfoCallout';
import { BlogArticleModuleMidPageCallToAction } from '../../BlogArticleModuleMidPageCallToAction';
import { BlogArticleModuleSplit } from '../../BlogArticleModuleSplit';
import { BlogArticleModuleTable } from '../../BlogArticleModuleTable';
import { BlogArticleModuleTestimonial } from '../../BlogArticleModuleTestimonial';
import { BlogArticleModuleVideo } from '../../BlogArticleModuleVideo';
import { BlogArticleModuleSection } from '../../BlogArticleSection';
import { BlogArticleModuleCenters } from '../BlogArticleModuleCenters';

type TBlogArticleModuleProps = {
  module: TBlogArticleModule;
  mobile?: boolean;
};

export const createUniqueClassNameForBlogArticleModule = (
  moduleId: string,
  mobile: boolean
) => `BlogArticleModule_${moduleId}_${mobile ? 'mobile' : 'desktop'}`;

export const BlogArticleModule: React.FC<TBlogArticleModuleProps> = ({
  module,
  mobile = false,
}) => {
  const item = (() => {
    switch (module.__typename) {
      case 'blogModuleFAQ': {
        return <BlogArticleModuleFAQs module={module} mobile={mobile} />;
      }

      case 'blogModuleVideo': {
        return <BlogArticleModuleVideo module={module} mobile={mobile} />;
      }

      case 'blogModuleArticleSection': {
        return <BlogArticleModuleSection module={module} mobile={mobile} />;
      }

      case 'blogModuleTestimonial': {
        return <BlogArticleModuleTestimonial module={module} mobile={mobile} />;
      }

      case 'blogModuleInfoCallout': {
        return <BlogArticleModuleInfoCallout module={module} mobile={mobile} />;
      }

      case 'blogModuleTable': {
        return <BlogArticleModuleTable module={module} mobile={mobile} />;
      }

      case 'blogModuleBlockQuote': {
        return <BlogArticleModuleBlockQuote module={module} mobile={mobile} />;
      }

      case 'blogModuleMidPageCTA': {
        return (
          <BlogArticleModuleMidPageCallToAction
            module={module}
            mobile={mobile}
          />
        );
      }

      case 'blogModuleSplit': {
        return <BlogArticleModuleSplit module={module} mobile={mobile} />;
      }

      case 'blogModuleCenters': {
        return <BlogArticleModuleCenters module={module} mobile={mobile} />;
      }

      default: {
        devLog(
          `BlogArticleModule: un__typenamed module reached: ${module.moduleId}.`
        );

        return null;
      }
    }
  })();

  if (!item) return null;

  return (
    <div
      className={clsx(
        'BlogArticleModule',
        createUniqueClassNameForBlogArticleModule(module.moduleId, mobile)
      )}
    >
      {item}
    </div>
  );
};
